import React from 'react'
import UsefulLinks from './UsefulLinks'

const UsefulLinksWrapper = () => {
  return <UsefulLinks></UsefulLinks>
}

export default UsefulLinksWrapper
